<script setup lang="ts">
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { api, jsonBody, setCsrfToken } from '../../services/api'

const route = useRoute()
const router = useRouter()
const email = ref('')
const password = ref('')
const error = ref('')
const busy = ref(false)

async function login() {
  busy.value = true
  error.value = ''
  try {
    const result = await api<{ csrfToken: string }>('/admin/auth/login', {
      method: 'POST',
      ...jsonBody({ email: email.value, password: password.value }),
    })
    setCsrfToken(result.csrfToken)
    await router.push(String(route.query.redirect ?? '/admin'))
  } catch (caught) {
    error.value = caught instanceof Error ? caught.message : 'Login failed.'
  } finally {
    busy.value = false
  }
}
</script>

<template>
  <main class="login-page">
    <section class="login-story">
      <RouterLink class="brand inverse" to="/"
        ><span class="brand-mark">✦</span><span>Message in a Bottle</span></RouterLink
      >
      <div>
        <p class="eyebrow">Wilson administration</p>
        <h1>Guide every journey from one quiet harbour.</h1>
        <p>Manage reusable messages, bottle movements, reports, and privacy-first moderation.</p>
      </div>
      <small>Private administrator area · No public accounts</small>
    </section>
    <section class="login-panel">
      <form @submit.prevent="login">
        <p class="eyebrow">Welcome back</p>
        <h2>Administrator login</h2>
        <p v-if="error" class="form-error" role="alert">{{ error }}</p>
        <label>Email<input v-model="email" type="email" autocomplete="username" required /></label
        ><label
          >Password<input
            v-model="password"
            type="password"
            autocomplete="current-password"
            minlength="12"
            required /></label
        ><button class="button primary wide" :disabled="busy">
          {{ busy ? 'Signing in…' : 'Sign in' }}</button
        ><RouterLink class="text-link centered" to="/">← Return to public site</RouterLink>
      </form>
    </section>
  </main>
</template>
